define('plugin/client-login/controller/ClientLoginController',['require','__original__/ClientLoginController'],function (require) {

    var BaseController = require('__original__/ClientLoginController');

    /**
     * Client login Controller
     *
     * @class ClientLoginController
     */
    return BaseController.extend({

        signOut: function () {
            this._handler.performSignOut();

            this._clientModel.navigateToSignIn();
        },

        signIn: function (back, message) {
            this._signIn(this.getMainLayout().getContentRegion(), '', message);
        },

        performRedirectBack: function () {
            if (!this._backUrl) {
                this._backUrl = '';
            }
            this._redirect(this._backUrl);
        }
    });

});
